/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { Cart } from '@msdyn365-commerce/retail-proxy';
import { lAC_AddOrderAllergensAsync } from '../custom-actions/DataActionExtension.g';
import { ILAC_AuthToken } from '../custom-actions/DataServiceEntities.g';
import { withFreshToken } from '../utils/authService';

/**
 * AddOrderAllergens Input Action
 */
export class AddOrderAllergensInput implements Msdyn365.IActionInput {
    public authTokenCookie: ILAC_AuthToken;
    public cartId: string;
    public customerId: string;
    public allergenCodes: string[];

    constructor(cartId: string, allergenCodes: string[], customerId: string, authTokenCookie: ILAC_AuthToken) {
        this.authTokenCookie = authTokenCookie;
        this.cartId = cartId;
        this.customerId = customerId;
        this.allergenCodes = allergenCodes;
    }

    public getCacheKey = () => `LACADDORDERALLERGENS${this.cartId}`;
    public getCacheObjectType = () => 'LACADDORDERALLERGENS';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * Adds allergens from the venue's list to the guest's cart.
 */
async function addOrderAllergensAsync(input: AddOrderAllergensInput, ctx: Msdyn365.IActionContext): Promise<Cart | undefined> {
    return withFreshToken(ctx, input.authTokenCookie, async carried =>
        lAC_AddOrderAllergensAsync({ callerContext: ctx }, carried, input.cartId, input.customerId, input.allergenCodes)
    );
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<Cart | undefined>>addOrderAllergensAsync,
    id: 'LACAddOrderAllergens'
});
